import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Switch from 'react-switch';
import './AdminBrandSettings.scss';

import { updateBrandSettings } from '../../../../Actions/BrandActions';
import { getBrandSettings, getBrandName } from '../../../../Helpers/user_helpers';

const AdminBrandSettings = props => {
  const { user } = props;

  // Allow them to send gifting only opportunities
  const canSendGiftingOnlyOpps = getBrandSettings(user).canSendGiftingOnlyOpps;
  const [isSendingGiftingOnlyOpps, setIsSendingGiftingOnlyOpps] = React.useState(false);
  const updateCanSendGiftingOnlyOpportunities = async () => {
    if (isSendingGiftingOnlyOpps) return window.ALERT.warn('Please wait for the previous request to complete.');
    setIsSendingGiftingOnlyOpps(true);
    await props.updateBrandSettings({ canSendGiftingOnlyOpps: !canSendGiftingOnlyOpps });
    window.ALERT.success(
      !canSendGiftingOnlyOpps
        ? `${getBrandName(user)} can now send gifting only opportunities.`
        : `${getBrandName(user)} can no longer send gifting only opportunities.`
    );
    setIsSendingGiftingOnlyOpps(false);
  };

  return (
    <div className='admin-brand-settings-container'>
      <div className='switch-container'>
        <Switch
          onChange={updateCanSendGiftingOnlyOpportunities}
          checked={canSendGiftingOnlyOpps}
          height={14}
          width={24}
          onColor='#11835a'
          offColor='#ccc'
          className='switch'
          checkedIcon={false}
          uncheckedIcon={false}
        />
        <div className='label'>Can Send Gifting Only Opportunities</div>
      </div>
    </div>
  );
};

AdminBrandSettings.propTypes = {
  user: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  const { user } = state;
  return { user };
};

export default connect(mapStateToProps, {
  updateBrandSettings
})(AdminBrandSettings);
